import React, { Component } from "react";

import { Container } from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import PaymentsForm from "../../../../../components/forms/PaymentsForm/PaymentsForm";
import PreloaderData from "../../../../../components/PreloaderData/index";

import {
  getBankUploadingById,
  updateBankUploading,
} from "../../../../../store/bank-uploading/actions";
import {
  getClientsList,
  getClientById,
} from "../../../../../store/clients/actions";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ModifiedMetaTags from '../../../../../components/ModifiedMetaTags/index';

class EditPayment extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const client_id = this.props.match.params.clientId;
    const payment_id = this.props.match.params.paymentId;
    this.props.getClientsList(this.props.clients);
    this.props.getClientById(client_id);
    this.props.getBankUploadingById(payment_id);
  }

  saveChanges = data => {
    this.props.updateBankUploading(this.props.match.params.paymentId, data);
    this.props.history.push(
      `/clients/${this.props.match.params.clientId}#payments`
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Edit payment| Mobihunter" />

          <Container fluid>
            {this.props.client?.legal_name && (
              <Breadcrumbs
                title={this.props.client?.legal_name}
                breadcrumbItem="Edit payment"
                link={`/clients/${this.props.match.params.clientId}#payments`}
              />
            )}
            {!this.props.loading ? (
              <>
                {Object.keys(this.props.data).length !== 0 && (
                  <PaymentsForm
                    data={this.props.data}
                    clientId={this.props.match.params.clientId}
                    clients={
                      this.props.clients.results.map(i => {
                        return {
                          label: i.legal_name,
                          value: i.id,
                        };
                      }) || []
                    }
                    loading={this.props.loading}
                    permissions={this.props.permissions}
                    updatePayment={this.saveChanges}
                  />
                )}
              </>
            ) : (
              <PreloaderData />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

EditPayment.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.node,
      paymentId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  data: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
  getBankUploadingById: PropTypes.func.isRequired,
  updateBankUploading: PropTypes.func.isRequired,
  getClientById: PropTypes.func.isRequired,
  getClientsList: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired,
  permissions: PropTypes.any,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  data: state.BankUploading.payment,
  client: state.Clients.client,
  clients: state.Clients.data,
  permissions: state.User.permissions,
  loading: state.BankUploading.loading,
});

export default withRouter(
  connect(mapStateToProps, {
    getBankUploadingById,
    updateBankUploading,
    getClientsList,
    getClientById,
  })(EditPayment)
);
